var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from "redux-saga/effects";
import { GET_DECLARATION_FORM_REQUEST, getDeclarationFormFailure, getDeclarationFormSuccess } from "../../actions";
import APIIN from "@/utils/APIIN";
const onGetDeclarationForm = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            APIIN.downloadLabel(action.payload.type === "GST_DECLARATION"
                ? `company/admin/gst/download?companyId=${action.payload.companyId}&type=${action.payload.type}`
                : `company/admin/gst/download?companyId=${action.payload.companyId}&type=${action.payload.type}&gstNumber=${action.payload.gstNumber}`)
                .then((data) => {
                resolve(data);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
// Strips out the live XHR/config/circular refs — only plain, serializable data survives
const toSerializableError = (error) => {
    var _a, _b, _c, _d, _e, _f;
    return ({
        message: (_d = (_c = (_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) !== null && _c !== void 0 ? _c : error === null || error === void 0 ? void 0 : error.message) !== null && _d !== void 0 ? _d : "Failed to download declaration form.",
        status: (_f = (_e = error === null || error === void 0 ? void 0 : error.response) === null || _e === void 0 ? void 0 : _e.status) !== null && _f !== void 0 ? _f : null,
    });
};
function* getDeclarationFormWorker(action) {
    try {
        const data = yield call(onGetDeclarationForm, action);
        yield put(getDeclarationFormSuccess(data));
    }
    catch (error) {
        yield put(getDeclarationFormFailure(toSerializableError(error)));
    }
}
export function* watchGetDeclarationForm() {
    yield takeLatest(GET_DECLARATION_FORM_REQUEST, getDeclarationFormWorker);
}
